var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"stars"},_vm._l(([1,2,3,4,5]),function(i){return _c('li',{key:i},[_c('font-awesome-icon',{staticClass:"icon",style:({fontSize: _vm.size}),attrs:{"icon":[_vm.score >= i ? 'fas' : 'far', 'star']}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }